export default __webpack_public_path__ + "static/open-sans-latin-300-normal-6dacce4cff13d02117d689b93a52d800.woff2";